import { render } from "./allBlogs.vue?vue&type=template&id=bae326ba"
import script from "./allBlogs.vue?vue&type=script&lang=js"
export * from "./allBlogs.vue?vue&type=script&lang=js"

import "./allBlogs.vue?vue&type=style&index=0&id=bae326ba&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__